import { render, staticRenderFns } from "./Wp_pdd_pay_data.vue?vue&type=template&id=7351be94&scoped=true&"
import script from "./Wp_pdd_pay_data.vue?vue&type=script&lang=js&"
export * from "./Wp_pdd_pay_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7351be94",
  null
  
)

export default component.exports